export enum ModerationStages {
  PREMODERATION = 1,
  MANUAL = 2,
  PASSED = 3,
  FAILED = 4,
}
